'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as notify } from 'redux-notifications';

import { ERROR } from '../../../consts';
import { CLAIM } from '../../../app/Claims/actionTypes';
import { createClaim, hideClaimForm } from '../../../app/Claims/actions';
import RadioGroup from '../RadioGroup';
import getDictionary from '../../../utils/dictionaries';

class ClaimForm extends Component {
  constructor (props) {
    super(props);

    this.state = {
      text: '',
      reasonId: null,
      errors: []
    };

    this.hideClaimForm = props.hideClaimForm.bind(this);
    this.createClaim = props.createClaim.bind(this);
    this.notifSend = props.notifSend.bind(this);

    this.handlerClose = this.handlerClose.bind(this);
    this.handlerChangeText = this.handlerChangeText.bind(this);
    this.handlerChangeReason = this.handlerChangeReason.bind(this);
    this.handlerCreateClaim = this.handlerCreateClaim.bind(this);

    this.clearErrors = () => this.setState({errors: []});
  }

  handlerClose (e) {
    e.preventDefault();
    e.stopPropagation();
    this.hideClaimForm();
  }

  handlerChangeText (e) {
    const text = e.target.value;
    this.setState({
      text
    });

    if (text) {
      this.clearErrors();
    }
  }

  handlerChangeReason (field, value) {
    this.setState({
      reasonId: value,
      errors: []
    }, () => this.commentInput && this.commentInput.focus());
  }

  handlerCreateClaim () {
    const { text, reasonId } = this.state;
    this.clearErrors();

    this.createClaim(reasonId, text)
      .then(action => {
        if (action.type === CLAIM + ERROR) {
          const errors = action.payload
            ? action.payload.map(err => err.message) : [];

          this.setState({
            errors
          });
        } else {
          this.notifSend({
            message: 'Жалоба отправлена',
            dismissAfter: 2000
          });
        }
      });
  }

  componentWillReceiveProps (nextProps, nextContext) {
    const realtyId = nextProps.form.get('realtyId');
    if (this.props.form.get('realtyId') !== realtyId) {
      this.setState({
        text: '',
        reasonId: null,
        errors: []
      });
    }
  }

  render () {
    const form = this.props.form;
    const isOpen = form.get('open') || false;
    const isLoading = form.get('loading') || false;
    const isReady = !!this.state.reasonId;
    const dealType = form.get('dealType');
    const realtyType = form.get('realtyType');
    const reasonList = dealType && realtyType ? this.props.dictionary.getClaimReasonItems(dealType, realtyType) : [];

    return (
      <div className={'modal full-screen' + (isOpen ? ' open fade in' : '')}>
        <div className='modal-dialog full-screen'>
          <div className='modal-content animate-top'>
            <div className='modal-box claim-modal'>
              <button type='button' className='close' onClick={this.handlerClose}>×</button>
              {
                isOpen && (
                  <div className={'form-container form' + (this.state.errors.length ? ' error' : '')}>
                    <h2 className='header'>Жалоба на объявление</h2>
                    <b style={{display: 'inline-block', margin: '12px 0 0'}}>Пожалуйста, укажите причину жалобы:</b>

                    <RadioGroup
                      items={reasonList}
                      name='calim_reason'
                      value={this.state.reasonId}
                      onUpdate={this.handlerChangeReason}
                    />

                    {
                      isReady && (
                        <div>
                          <label className='comment-label'>Добавьте комментарий:</label>
                          <textarea
                            ref={(input) => { this.commentInput = input; }}
                            autoFocus
                            value={this.state.text}
                            cols='10' rows='10'
                            onChange={this.handlerChangeText} />
                        </div>
                      )
                    }

                    { this.state.errors.map(err => (<span className='error-message'>{err}</span>)) }

                    <div className='controls'>
                      {
                        isLoading ? (
                          <span>идет отправка жалобы ...</span>
                        ) : (
                          <button type='button' disabled={!isReady}
                            onClick={this.handlerCreateClaim}
                            className='btn btn-primary'>
                            Отправить
                          </button>
                        )
                      }
                    </div>
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <TransitionGroup>
          {
            isOpen &&
            <CSSTransition key={'modal-backdrop'} appear classNames='fade' timeout={300}>
              <div className='modal-backdrop full-screen' />
            </CSSTransition>
          }
        </TransitionGroup>
      </div>
    );
  }
}

ClaimForm.propTypes = {
  form: PropTypes.object.isRequired,
  dictionary: PropTypes.object.isRequired,
  hideClaimForm: PropTypes.func.isRequired,
  createClaim: PropTypes.func.isRequired,
  notifSend: PropTypes.func.isRequired
};

ClaimForm.defaultProps = {};

function mapStateToProps (state) {
  return {
    form: state.getIn(['claims', 'form']),
    dictionary: getDictionary(state.get('dictionaries'))
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    hideClaimForm,
    createClaim,
    notifSend: notify.notifSend
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimForm);



// WEBPACK FOOTER //
// ./src/ui/Controls/Claims/ClaimForm.jsx